//------------------//
// Import GSAP & ScrollTrigger
//------------------//
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);






//------------------//
// Import Alpine.js
// Adds Alpine components
//------------------//
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
global.Alpine = Alpine;
Alpine.plugin(collapse);

const menuTimeline = gsap.timeline({ paused: true });
const links = document.querySelectorAll('#nav > li');

Alpine.data('openMenus', () => ({
    init() {

        menuTimeline.from(links, {
            duration: 1,
            opacity: 0,
            y: 20,
            stagger: 0.1,
        });
    },

    desktopMenuOpen: false,
    searchOpen: false,

    body: {
        ['@keydown.escape']() {
            this.closeDesktopMenu();
            this.closeSearch();
        }
    },

    openDesktopMenu() {
        this.desktopMenuOpen = true;
        menuTimeline.play();
    },

    closeDesktopMenu() {
        this.desktopMenuOpen = false;
        menuTimeline.reverse();
    },

    openSearch() {
        this.searchOpen = true;
    },

    closeSearch() {
        this.searchOpen = false;
    }
}));

Alpine.start();



//------------------//
// Lazy load images
//------------------//
import Lazyload from 'vanilla-lazyload';
global.Lazyload = Lazyload;

// Create Lazy load instance
var lazyLoadInstance = new Lazyload({
    elements_selector: '.lazy'
    // ... more custom settings?
});
global.lazyLoadInstance = lazyLoadInstance;





//------------------//
// Swiper JS
//------------------//
import Swiper, { Navigation } from 'swiper';
// import Swiper styles
import 'swiper/css';
global.Swiper = Swiper;
global.Navigation = Navigation;




//------------------//
// Import Fancybox
//------------------//
import { Fancybox } from "@fancyapps/ui";





//------------------//
// Oak leaf scroll parallax animation
//------------------//
gsap.utils.toArray(".oak-leaf-parallax").forEach(function(container) {
    const oakLeaf = container.querySelector(".oak-leaf");

    gsap.set(oakLeaf, { y: '-50px'});

    gsap.to(oakLeaf, {
        y: '50px',
        ease: "none",
        scrollTrigger: {
            scrub: 1,
            trigger: container,
            // markers: true,
        },
    });
});





//------------------//
// Memphis map backgroud scroll parallax animation
//------------------//
gsap.utils.toArray(".map-parallax").forEach(function(container) {
    const map = container.querySelector(".map");

    gsap.set(map, { y: '-50px'});

    gsap.to(map, {
        y: '50px',
        ease: "none",
        scrollTrigger: {
            scrub: 1,
            trigger: container,
            // markers: true,
        },
    });
});





//------------------//
// Hero background parallax scroll animation
//------------------//

const hero = document.querySelector("#hero");
const heroContent = hero.querySelector(".hero-content");

gsap.from(heroContent, {
    y: 10,
    opacity: 0,
    duration: 1,
    filter: "blur(2px)"
});





//------------------//
// Scroll Fade In with small Y Translate
//------------------//
gsap.set(".list-fadeInUp", {
    y: 25,
    opacity: 0,
    filter: "blur(2px)"
});

ScrollTrigger.batch('.list-fadeInUp', {
    onEnter: batch => gsap.to(batch, {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.25,
        filter: "blur(0px)"
    })
});
